import React, { useState } from "react";

function ContactUs() {
    const [form, setForm] = useState({ name: "", email: "", message: "" });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        alert("Your message has been submitted. Our team will contact you soon.");
        setForm({ name: "", email: "", message: "" });
    };

    return (
        <div className="max-w-3xl mx-auto p-6 bg-white rounded shadow">
            <h1 className="text-3xl font-bold mb-4">Contact Us</h1>
            <p className="mb-4">
                Have questions, feedback, or need assistance? We’re here to help. Reach
                out to us through any of the following methods:
            </p>
            <ul className="mb-6 space-y-2">
                <li><strong>Email:</strong> support@shopease.com</li>
                <li><strong>Phone:</strong> +91-9876543210</li>
                <li><strong>Address:</strong> 123 Market Street, New Delhi, India</li>
            </ul>
            <h2 className="text-xl font-semibold mb-2">Send us a Message</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
                <input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    value={form.name}
                    onChange={handleChange}
                    required
                    className="w-full border p-2 rounded"
                />
                <input
                    type="email"
                    name="email"
                    placeholder="Your Email"
                    value={form.email}
                    onChange={handleChange}
                    required
                    className="w-full border p-2 rounded"
                />
                <textarea
                    name="message"
                    placeholder="Your Message"
                    value={form.message}
                    onChange={handleChange}
                    required
                    rows="5"
                    className="w-full border p-2 rounded"
                />
                <button
                    type="submit"
                    className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                >
                    Submit
                </button>
            </form>
        </div>
    );
}

export default ContactUs;
